import {
  LAPSED_SUBSCRIPTION_COPY,
  SHOWN_EVENT_SESSION_KEY_PREFIX,
} from "./constants";

import type { LapsedSubscriptionReason } from "./constants";

function buildShownSessionKey(companyId: number): string {
  return `${SHOWN_EVENT_SESSION_KEY_PREFIX}:${companyId}`;
}

// Own keys only: `in` would also accept inherited names like "constructor".
function isLapsedSubscriptionReason(
  value: string | null,
): value is LapsedSubscriptionReason {
  return value !== null && Object.hasOwn(LAPSED_SUBSCRIPTION_COPY, value);
}

// The reason this company's banner was last shown for, which is what a
// subsequent flip to active recovered from. One key per company rather than one
// per company/reason pair: a pair-per-key layout only records which reasons were
// seen at some point, so it cannot name the one that was actually on screen.
//
// sessionStorage survives deploys, so a reason renamed since an older tab wrote
// it would otherwise reach the recovery event verbatim.
export function getShownReasonOrNull(
  companyId: number,
): LapsedSubscriptionReason | null {
  const stored = window.sessionStorage.getItem(buildShownSessionKey(companyId));
  return isLapsedSubscriptionReason(stored) ? stored : null;
}

export function hasCapturedShown(
  companyId: number,
  reason: LapsedSubscriptionReason,
): boolean {
  return getShownReasonOrNull(companyId) === reason;
}

export function markShownCaptured(
  companyId: number,
  reason: LapsedSubscriptionReason,
): void {
  window.sessionStorage.setItem(buildShownSessionKey(companyId), reason);
}

export function clearShownCaptured(companyId: number): void {
  window.sessionStorage.removeItem(buildShownSessionKey(companyId));
}
